import React, { useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { Redirect } from 'react-router-dom'

export default function Index() {
  const { oktaAuth } = useOktaAuth()

  const logout = async () => {
    await oktaAuth.signOut();
    oktaAuth.tokenManager.clear()
  }

  useEffect(() => {
    logout()
  }, [])

  return (
    <Redirect
      to={{
        pathname: "/login",
      }}
    />
  )
}
